<script lang="ts">
    import {FeatherShare2} from "@anyways-open/common-svgs"
    import type { ToolBoxManager } from "../toolbox/ToolBoxManager";

    export let manager: ToolBoxManager<string>;
    let openToolBox = manager.getOpenToolBoxStore();

    // click event, toggle layer on/off.
    const onClick = () => {
        if ($openToolBox === "share") {
            $openToolBox = "none";
        } else {
            $openToolBox = "share";
        }
    };

    const todo = () => {};
</script>

<div on:click={onClick} on:keydown={todo} class="btn btn-toolbox {$openToolBox == "share" ? 'active' : ''}">
    <FeatherShare2 class="toolbox-icon" />
</div>


<style>
    .btn-toolbox {
        color: #fff;
    }
</style>